export class StringUtilities {

  public static ToSingular(word: string): string {
    if (!word) return word;

    const trimmed = word.trim();
    if (trimmed.length < 3) return trimmed;

    if (trimmed.toLowerCase().endsWith("ones")) {
      return trimmed.slice(0, -4) + "ón";
    }

    if (trimmed.toLowerCase().endsWith("res")) {
      return trimmed.slice(0, -2);
    }

    if (trimmed.toLowerCase().endsWith("nes")) {
      return trimmed.slice(0, -2);
    }

    if (trimmed.toLowerCase().endsWith("s")) {
      return trimmed.slice(0, -1);
    }

    return trimmed;
  }
}
